import { Injectable } from '@angular/core';
import { Observable, catchError, of, switchMap, tap } from 'rxjs';
import { Store } from '../../../../../services/store';
import { toVoid } from '../../../../../utils/void';
import { OrderNotesProvider } from './order-notes.provider';
import { OrderNoteDto } from './order-note.dto';

export interface OrderNotesState {
  loading: boolean;
  notes: OrderNoteDto[] | undefined;
  saving: boolean;
  saveError: string | undefined;
}

const INITIAL_STATE: OrderNotesState = {
  loading: false,
  notes: undefined,
  saving: false,
  saveError: undefined
};

@Injectable({ providedIn: 'root' })
export class OrderNotesStore extends Store<OrderNotesState> {
  constructor(private provider: OrderNotesProvider) {
    super(INITIAL_STATE);
  }

  init(orderId: number | undefined): Observable<void> {
    if (orderId === undefined) {
      // zlecenie not saved in backend yet (/orders/new) — nothing can be noted on it
      this.update(state => ({ ...state, loading: false, notes: [], saveError: undefined }));
      return of(undefined);
    }

    this.update(state => ({ ...state, loading: true, saveError: undefined }));

    return this.provider.getNotes(orderId)
      .pipe(
        tap(notes => {
          this.update(state => ({
            ...state,
            loading: false,
            notes
          }));
        }),
        toVoid()
      );
  }

  create(orderId: number, content: string): Observable<void> {
    this.update(state => ({ ...state, saving: true, saveError: undefined }));

    return this.provider.createNote(orderId, content)
      .pipe(
        tap(() => this.update(state => ({ ...state, saving: false }))),
        switchMap(() => this.init(orderId)),
        catchError(error => {
          this.update(state => ({
            ...state,
            saving: false,
            saveError: typeof error.error === 'string' ? error.error : 'Nie udało się zapisać notatki'
          }));
          return of(undefined);
        })
      );
  }
}
